<template>
  <div>
      <top-navbar></top-navbar>
<div>
<!-- v-if="showMap" -->


<div class="  background_color">
<h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/issuetracking/index"> {{language[1]['Home']}} </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Issue Tracking<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{language[4]['Manage Issue']}}</h6>

<!-- <h6 class="custom-maintitle "><b>Issue Tracking</b></h6> -->

<div class="container-fluid">
    <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

      <div class="d-flex">
        <b-input-group size="sm" style="width: 225px;">
          <b-form-input id="filter-input" v-model="filter" type="search" :placeholder="language[10]['Search']">
          </b-form-input>
          
  </b-input-group>





  <div style="margin-top: 11px;" class="ms-2" >
  <span class="custom-breadcrumb">{{language[11]['Showing ']}} {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} {{language[13]['items']}}.</span>
</div>

      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        <!-- <button type="button" @click="showallMap()" class="btn btn-sm btn-outline-primary bdr-rad"></button>  -->
<button @click="exportToExcel"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">{{language[122]['Export to Excel']}}</button>
<!-- <button  @click="showallMap()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">{{language[121]['Show all in Map']}}</button> -->
<button  @click="IssueCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">{{language[102]['Create Issue']}}</button>


</div>



    
</div>

<div>
<div v-if="isCalendarVisible" class="calendar-popup">
  <h4 class="popup-heading">{{language[134]['Select Future Date']}}</h4>
    <div ref="calendarElement" class="calendar-widget"></div>
    <div class="button-group">
      <button @click="saveDate" class="mr-1 btn btn-outline-primary   font-size_def bdr-rad">{{language[81]['Save']}}</button>
      <button @click="closeCalendar" class="mr-1 btn btn-outline-primary  font-size_def bdr-rad">{{language[135]['Close']}}</button>
    </div>
  </div>
<b-modal :id="infoModal2.id" 
 @shown="initGoogleMap"
 size="xl" hide-footer
  class="top-modal">
 <div>
  <div id="map"  ></div>
 </div>

</b-modal>



<b-modal :id="infoModal4.id" 
 
 size="xl" hide-footer
  class="top-modal">
  <div id="map" style="height: 600px; width: 100%;"></div>
  <div v-if="clickedLocation">
    <!-- <p>Latitude: {{ clickedLocation.lat }}</p>
    <p>Longitude: {{ clickedLocation.lng }}</p> -->
  </div>


</b-modal>





<b-modal :id="infoModal1.id" 
   :header-bg-variant="headerBgVariant"
    :header-text-variant="headerTextVariant"
    size="sm" hide-footer
   bottom>
  <template  #modal-title>
   
    <h5 >{{language[37]['Allocate to Contractor']}}</h5>


  </template>
  
 <div>

 
  <table class="table table-sm table-borderless">
    <tbody>
      <tr>
      <td style="width: 10px;">  <b-icon @click="remove" v-show="this.count>0 && noloadMerge" class="ms-1 me-1 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
      <td>  <v-select  v-model="detail[0].contractor" :options="contracs" @input="showMerge()"  label="name" ></v-select></td>
      <td  style="width: 10px;"><b-icon @click="add" v-show="noloadMerge" class=" mt-1 ms-1"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
      </tr>

      <tr v-show="noloadMerge" v-for="key in count" :key="key">
      <td style="width: 10px;">  <b-icon @click="remove" class="ms-1 me-1 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
      <td>  <v-select  v-model="detail[key].contractor"  :options="contracs"  label="name"></v-select></td>
      <td  style="width: 10px;"> <b-icon @click="add" class=" mt-1 ms-1"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
      </tr>
 
      <tr v-show="loadMerge">
      <td style="width: 10px;">  </td>
      <td>  <v-select  v-model="det" :options="issuejobs"  label="issue_no" :multiple="true"></v-select></td>
      <td  style="width: 10px;"></td>
      </tr>
    </tbody>
    
  </table>


 </div>
 <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
  
  <div class="d-flex  ">
    <div class="form-check form-switch ms-4
    ">
                
                      <input 
                    v-model="mergecon"  
                    @change="showMerge()" 
                    class="form-check-input mt-4" 
                    type="checkbox" 
                  >
                <label class="form-check-label mt-3 " >{{language[123]['Jobs to Merge']}}</label>
                  </div>
  </div>
  <div class="d-flex  ">
   
      <button  type="button" @click="allocateSubmit(infoModal1.content)"  class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[30]['Allocate']}}</button>
  </div>
  </div>
 <!-- <div class="modal-footer">

    <button type="button" @click="allocateSubmit(infoModal1.content)" class="btn btn-sm btn-outline-primary bdr-rad">Allocate</button>
  </div> -->



</b-modal>

<b-modal :id="infoModal3.id" 
   :header-bg-variant="headerBgVariant"
    :header-text-variant="headerTextVariant"
    size="sm" hide-footer
   bottom>
  <template  #modal-title>
   
    <h5 >{{language[37]['Allocate to Contractor']}}</h5>


  </template>
  
 <div>

 
  <table class="table table-sm table-borderless">
    <tbody>
      <tr>
      <td style="width: 10px;">  <b-icon @click="remove" v-show="this.count>0" class="ms-1 me-1 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
      <td>  <v-select  v-model="detail[0].contractor" :options="contracs"  label="name" ></v-select></td>
      <td  style="width: 10px;"><b-icon @click="add" class=" mt-1 ms-1"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
      </tr>

      <tr v-for="key in count" :key="key">
      <td style="width: 10px;">  <b-icon @click="remove" class="ms-1 me-1 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
      <td>  <v-select  v-model="detail[key].contractor"  :options="contracs"  label="name"></v-select></td>
      <td  style="width: 10px;"> <b-icon @click="add" class=" mt-1 ms-1"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
      </tr>
    </tbody>
    
  </table>


 </div>
 <div class="modal-footer">
    
 
    <button type="button" @click="reopenSubmit(infoModal3.content)" class="btn btn-sm btn-outline-primary bdr-rad">{{language[30]['Allocate']}}</button>
  </div>



</b-modal>



</div>


<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body ">


<b-table responsive style="font-size: small;"   class="table-hover"
    :items="filteredItems"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
  
    :filter="filter"
    :filter-included-fields="filterOn"
    :sort-by.sync="sortBy"
       head-variant="dark"
    
    :sort-desc.sync="sortDesc"
    :sort-direction="sortDirection"

    show-empty
    small
   
  >

  

  <template #cell(description)="row">
<div>
  <span v-if="!row.item.showMore">
    {{ row.item.description.length > 150 ? row.item.description.slice(0, 150) + '...' : row.item.description }}
  </span>
  <span v-else>
    {{ row.item.description }}
  </span>
  <button
    class="btn btn-link btn-sm p-0"
    v-if="row.item.description.length > 150"
    @click="toggleShowMore(row.item)"
  >
    {{ row.item.showMore ? 'Less' : 'More' }}
  </button>
</div>
</template>

  <!-- @filtered="onFiltered" -->
    <template #cell(statusmy)="row">
      <div class="open-status" v-show="row.item.status==20" >{{ row.item.status1 }} </div>
      <div class="close-status" v-show="row.item.status==21" >{{ row.item.status1 }} </div>
      <div class="reopen-status" v-show="row.item.status==51" >{{ row.item.status1 }} </div>
      <div class="inprogress-status" v-show="row.item.status==25" >{{ row.item.status1 }} </div>
      <div class="active-status" v-show="row.item.status==1" >{{ row.item.status1 }} </div>
      <div class="pause-status" v-show="row.item.status==53" >{{ row.item.status1 }} </div>

      
      <div style="background-color: #ee68f9;text-align: center;border-radius: 12px;padding: 4px;" v-show="row.item.status==42" >{{ row.item.status1 }} </div>
     
      <div  v-show="row.item.status==49" style="background-color: green;text-align: center;border-radius: 12px;padding: 4px;">{{ row.item.status1 }} </div>
      
    </template>

    <template #cell(actions)="row">

      <div class="dropdown">
<button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
  {{language[24]['Actions']}}
</button>
<div class="dropdown-menu bdr-rad">
  <a class="dropdown-item mouse-cursor"@click="viewLoad(row.item.id)"  > {{language[28]['View']}}</a>
  <!-- <a class="dropdown-item mouse-cursor"@click="viewMap(row.item.id)"  >{{language[29]['View Map']}}</a> -->
  <a v-show="![49, 51].includes(row.item.status)" class="dropdown-item mouse-cursor"    @click="Allocate(row.item.id)">{{language[30]['Allocate']}}</a>
  
  <a v-show="![49, 51].includes(row.item.status)" class="dropdown-item mouse-cursor"   @click="loadSplit(row.item.id)"    >{{language[129]['Split']}}</a>
  <a v-show="![49, 51].includes(row.item.status)" class="dropdown-item mouse-cursor"  @click="showCalendar(row.item.id)"  >{{language[130]['Paused']}}</a>
  <a  v-show="[49, 51, 21].includes(row.item.status)" class="dropdown-item mouse-cursor"    @click="Reopen(row.item.id)">{{language[103]['Re-open']}}</a>
  

</div>
</div>
</template>


    <template #row-details="row">
      <b-card>
        <ul>
          <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
        </ul>
      </b-card>
    </template>
  </b-table>
  
    <b-col  style="padding-left: 0px;padding-bottom: 0px;" sm="7" md="2" class="my-1 ">
      <b-pagination   v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" ></b-pagination>
    </b-col>

    


   
  


</div>
</div>
</div>
<br><br>

</div>









</div>






      
      <content-footer></content-footer>
  </div>
</template>
<script>
import axios from 'axios';
import vSelect from 'vue-select';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue'
import ContentFooter from './../../layout/ContentFooter.vue'

export default {
  data() {
    return {
      isCalendarVisible: false,
    selectedDate: null,
    currentItemId: null, 
      access_token:authService.isLoggedIn(),
      userid:authService.isUserid(),
      language:JSON.parse(authService.isLanguage()),
      sortBy: '',
      count: 0,
      sortDesc: false,
      loadMerge: false,
      noloadMerge: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      issue_det: [],
      det: [],
      totalRows: 1,
      currentPage: 1,
      mergecon: false,
      perPage: 15,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      fields: [],
      map: null, // Controls the visibility of the modal
    latitude: null, // Store latitude
    longitude: null,
      issues:[],
      contracs:[],
      issuejobs:[],
      detail:[
    {},  
    ],

    filters:{
      issue_no: '',
    },
    
      


      infoModal1: {
        id: 'info-modal1',
        title: '',
        content: [],
      },
      infoModal2: {
        id: 'info-modal2',
        title: '',
        content: [],
      },
      infoModal3: {
        id: 'info-modal3',
        title: '',
        content: [],
      },
      infoModal4: {
        id: 'info-modal4',
        title: '',
        content: [],
      },
    


      
    }

  },

  created(){
    this.loadIssue();
  },
  computed: {

    filteredItems() {
  return this.issues.filter((item) => {
    // Filter by ID
    const matchesIssueNo =
    !this.filters.issue_no ||
    String(item.issue_no).toLowerCase().includes(this.filters.issue_no.toLowerCase());

    const matchesname1 =
    !this.filters.name1 ||
    String(item.name1).toLowerCase().includes(this.filters.name1.toLowerCase());

    const matchesmain_category =
    !this.filters.main_category ||
    String(item.main_category).toLowerCase().includes(this.filters.main_category.toLowerCase());

    const matchessub_category =
    !this.filters.sub_category ||
    String(item.sub_category).toLowerCase().includes(this.filters.sub_category.toLowerCase());

    const matchesmobile =
    !this.filters.mobile ||
    String(item.mobile).toLowerCase().includes(this.filters.mobile.toLowerCase());

    const matchesemail =
    !this.filters.email ||
    String(item.email).toLowerCase().includes(this.filters.email.toLowerCase());

    const matchesaddress =
    !this.filters.address ||
    String(item.address).toLowerCase().includes(this.filters.address.toLowerCase());

    const matchesdescription =
    !this.filters.description ||
    String(item.description).toLowerCase().includes(this.filters.description.toLowerCase());

    const matchesstatusmy =
    !this.filters.statusmy ||
    String(item.statusmy).toLowerCase().includes(this.filters.statusmy.toLowerCase());

    const matchescreated_date =
    !this.filters.created_date ||
    String(item.created_date).toLowerCase().includes(this.filters.created_date.toLowerCase());

    const matchesresponsible =
    !this.filters.responsible ||
    String(item.responsible).toLowerCase().includes(this.filters.responsible.toLowerCase());

    const matchesupdate_date =
    !this.filters.update_date ||
    String(item.update_date).toLowerCase().includes(this.filters.update_date.toLowerCase());

  
    return matchesIssueNo &&  matchesname1 && matchesmain_category && matchessub_category && matchesmobile && matchesemail && matchesaddress && matchesdescription && matchesstatusmy && matchescreated_date && matchesresponsible && matchesupdate_date;
  });
},

  },



  mounted(){
   
    
    // { key: 'main_category', label:this.language[16]['Main Category'], sortable: true  },
    // { key: 'sub_category', label: this.language[17]['Sub Category'], sortable: true  },
   // { key: 'responsible', label: this.language[119]['Case Manager'], sortable: true  },

this.fields= [
        { key: 'issue_no', label: this.language[14]['Ticket Number'], sortable: true, sortDirection: 'desc' },
        { key: 'name1', label: this.language[15]['Citizen Name'], sortable: true,  },
       
        { key: 'mobile', label: this.language[18]['Citizen Mobile'], sortable: true  },
        { key: 'email', label: this.language[19]['Citizen Email'], sortable: true  },
        { key: 'address', label: this.language[20]['Address'], sortable: true  },
        { key: 'description', label: this.language[21]['Description'], sortable: true  },
        { key: 'statusmy', label: this.language[22]['Status'], sortable: true  },
   
        { key: 'created_date', label: this.language[23]['Created Date'], sortable: true  },
        { key: 'update_date', label: this.language[120]['Last Updated'], sortable: true  },
       
       
        
        { key: 'actions', label: this.language[24]['Actions'],  }
      ];


  },
methods : {


showCalendar(itemId) {
    this.currentItemId = itemId;
    this.isCalendarVisible = true;

    this.$nextTick(() => {
      // Initialize Flatpickr on the calendar element
      flatpickr(this.$refs.calendarElement, {
        inline: true, // Displays calendar directly
        dateFormat: "Y-m-d",
        onChange: (selectedDates, dateStr) => {
          this.selectedDate = dateStr; // Update the selected date
        },
      });
    });
  },
  async saveDate() {
    console.log("Selected Date:", this.selectedDate);
    console.log("Item ID:", this.currentItemId);
   

    try {
const { data} = await  axios.post('/issuetracking/savepaused?id='+this.currentItemId,{selectedDate:this.selectedDate},{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);
 if(data.status==200){
  this.closeCalendar();   
  this.loadIssue(); 
 }

} catch (error) {
console.log(error.response);
}



    // Perform actions like updating the backend or UI here
  },
  closeCalendar() {
    this.isCalendarVisible = false;
  },







toggleShowMore(item) {
    if (item.showMore === undefined) {
      this.$set(item, 'showMore', false); // Initialize the property if it doesn't exist
    }
    item.showMore = !item.showMore; // Toggle the value
  },

viewLoad(id){
  this.$router.push('/issuetracking/view?id='+id);
},
loadSplit(id){
  this.$router.push('/issuetracking/createsplit?id='+id);
},
IssueCreate(){
  this.$router.push('/issuetracking/create');
},

loadIssue(id) {

this.filterOn = id;
},


async viewMap(id){


try {
const { data} = await  axios.get('/issuetracking/loadmap?id='+id,{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);
 if(data.status==200){
        this.latitude = data.lan;
        this.longitude = data.lng;
        this.infoModal2.content = id;
        this.$root.$emit('bv::show::modal', this.infoModal2.id);
       
 }

} catch (error) {
console.log(error.response);
}

},


initializeMap() {
const defaultLocation = { lat: 59.3287, lng: 18.2507 }; // Default location (Sweden)

// Define Sweden's bounds using LatLngBounds
const swedenBounds = new google.maps.LatLngBounds(
  new google.maps.LatLng(55.005, 11.0274), // Southwest corner of Sweden
  new google.maps.LatLng(69.1062, 24.1553)  // Northeast corner of Sweden
);

// Create a map instance centered in Sweden
const mapDiv = document.getElementById("map");
console.log(mapDiv)
    if (mapDiv) {
      this.map = new google.maps.Map(mapDiv, {
        center: defaultLocation,
        zoom: 12,
        restriction: {
          latLngBounds: swedenBounds,
          strictBounds: false,
        },
      });

  

      this.geocoder = new google.maps.Geocoder();
      const input = this.$refs.autocomplete;
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'se' },
      });

      // Set up event listeners
    

      this.issue_det.forEach((issue) => {
const position = { lat: parseFloat(issue.latitude), lng: parseFloat(issue.longitude) };

if (swedenBounds.contains(position)) {
  const marker = new google.maps.Marker({
    position,
    map: this.map,
    
  });

  // Info window to display on hover
  let statusHtml = ''; // Initialize statusHtml

if (issue.statusvalue === 1) {
statusHtml = `<span style="color:red;">${issue.status}</span>`;
} else if (issue.statusvalue === 42) {
statusHtml = `<span style="color:#ee68f9;">${issue.status}</span>`;
} else if (issue.statusvalue === 49) {
statusHtml = `<span style="color:green;">${issue.status}</span>`;
} else if (issue.statusvalue === 21) {
statusHtml = `<span style="color:green;">${issue.status}</span>`;
}else if (issue.statusvalue === 51) {
statusHtml = `<span style="color:#f8a081;">${issue.status}</span>`;
}

// Construct the InfoWindow content
let infoWindowContent;
if(issue.statusvalue === 52){
infoWindowContent = `
<div>
  <h5 style="color:#007bff;"> ${issue.tiketnum}</h5>
 
<span style="font-size:14px;"><b>
   ${issue.address}.<br>
 
</span>
</div>
`; 
}else{
infoWindowContent = `
<div>
  <h5 style="color:#007bff;">${this.language[138]['Case']} ${issue.tiketnum}</h5>
 
<span style="font-size:14px;"><b>
   ${issue.address}.<br>
  <strong>${this.language[124]['Ticket']} #:</strong> ${issue.tiketnum}<br>
  <strong>${this.language[139]['Category']}:</strong> ${issue.maincat}<br>
  <strong>${this.language[17]['Sub Category']}:</strong> ${issue.msubcat}<br><br>
  <strong>${this.language[22]['Status']}:</strong><b> ${statusHtml}</b><br></b>
</span>
</div>
`; 
}

// Construct the InfoWindow content


  const infoWindow = new google.maps.InfoWindow({
  
    content: infoWindowContent,
  });




  // Show info window on mouseover
  marker.addListener("mouseover", () => {
    infoWindow.open(this.map, marker);
  });

  // Hide info window on mouseout
  marker.addListener("mouseout", () => {
    infoWindow.close();
  });
  marker.addListener("click", () => {
    this.issue.lat = issue.latitude;
    this.issue.lng = issue.longitude;
    this.searchAddress = issue.address;

    // Optionally, center the map on the clicked marker
  
  });
} else {
  console.warn(`Issue ID ${issue.id} is outside Sweden and won't be displayed.`);
}
});
      

    } else {
      console.error("Map div not found");
    }

// Reverse Geocoder instance to get address from lat/lng


// When a place is selected from the autocomplete dropdown
this.autocomplete.addListener('place_changed', this.handlePlaceSelect);

// Add map click listener to load address and lat/lng

},

// Handle place selection from the dropdown
handlePlaceSelect() {
const place = this.autocomplete.getPlace();
if (!place.geometry) {
  alert("No geometry found for this place");
  return;
}

// Get the location's latitude and longitude

},

initGoogleMap() {
  
    if (this.latitude && this.longitude) {
   
      // Initialize Google Map
      const map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) },
        zoom: 13
      });

      // Add a marker at the specified latitude and longitude
      const marker = new google.maps.Marker({
        position: { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) },
        map: map,
        title: 'Location of the issue'
      });
    }
  },
  closeMap() {
    this.showMap = false;
    this.latitude = null;
    this.longitude = null; // Reset coordinates when closing the map
  },

  async Reopen(id){


try {
const { data} = await  axios.get('/issuetracking/allocate?id='+id,{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);
 if(data.status==200){
  this.contracs = data.contracs;
 
  this.infoModal3.content = id;
  this.$root.$emit('bv::show::modal', this.infoModal3.id);
 }

} catch (error) {
console.log(error.response);
}



},







async Allocate(id){


  try {
    const { data} = await  axios.get('/issuetracking/allocate?id='+id,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     if(data.status==200){
      this.contracs = data.contracs;
      this.infoModal1.content = id;
      this.$root.$emit('bv::show::modal', this.infoModal1.id);
     }
    
  } catch (error) {
    console.log(error.response);
  }

 

},

async showallMap(){

  this.$root.$emit('bv::show::modal', this.infoModal4.id);
try {
const { data} = await  axios.post('/issuetracking/loadplease',{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);

 if(data.status==200){
  this.issue_det = data.issue_det;
  this.initializeMap();
     // window.location.reload();

  
 
 }

} catch (error) {
console.log(error.response);

}



},


async showMerge(){
console.log("aaa");
if(this.mergecon==true){
  this.loadMerge=true;
  this.noloadMerge=false;
  try {
const { data} = await  axios.post('/issuetracking/loadmergdata',{detail:this.detail},{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);
 if(data.status==200){
  this.issuejobs = data.issuejobs;
 }

} catch (error) {
console.log(error.response);
}

}else if(this.mergecon==false){
  this.loadMerge=false;
  this.noloadMerge=true;
}



  

},


async allocateSubmit(id){

  this.$root.$emit('bv::hide::modal', this.infoModal1.id);
  try {
    const { data} = await  axios.post('/issuetracking/allocatecreate?id='+id,{userid:this.userid,mergecon:this.mergecon,detail:this.detail,det:this.det},{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     if(data.status==200){
      window.location.reload();
    
      
     
     }
    
  } catch (error) {
    console.log(error.response);
    
  }

 

},


async reopenSubmit(id){

this.$root.$emit('bv::hide::modal', this.infoModal3.id);
try {
const { data} = await  axios.post('/issuetracking/reopencreate?id='+id,{userid:this.userid,detail:this.detail},{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);
 if(data.status==200){
 // window.location.reload();

  
 
 }

} catch (error) {
console.log(error.response);

}



},


    async fixMy(id) {
  console.log(this.access_token);
  try {
    const { data} = await  axios.get('/issuetracking/fix?id='+id,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     if(data.status==200){
      this.loadIssue();
     }
    
  } catch (error) {
    console.log(error.response);
  }
},
async loadIssue() {




  try {
    const { data} = await  axios.get('/issuetracking/index',{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
       this.issues = data.issues;
      this.totalRows =  this.issues.length;
    
  } catch (error) {
    console.log(error.response);
  }
},
exportToExcel() {
// Determine the data to export (filtered or all items)
const dataToExport = this.filteredItems.length ? this.filteredItems : this.issues;

// Prepare the data in a worksheet format
const worksheetData = dataToExport.map((item, index) => {
  const result = { '#': index + 1 }; // Add a sequential number column
  this.fields.forEach((field) => {
    if (field.key !== 'actions') {
      // Include the status key in the export
      if (field.key === 'statusmy') {
        result[field.label] = item.status1 || '';  // Use the actual status value
      } else {
        result[field.label] = item[field.key] || ''; // Use label as header
      }
    }
  });
  return result;
});

// Add a custom heading to the worksheet
const worksheet = XLSX.utils.json_to_sheet([]);

// Add the heading
XLSX.utils.sheet_add_aoa(worksheet, [['Issue Tracking Report']], { origin: 'A1' });

// Merge the heading row across columns
const colSpan = Object.keys(worksheetData[0] || {}).length;
if (colSpan > 1) {
  worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: colSpan - 1 } }];
}

// Style the heading row
worksheet['A1'].s = {
  font: { bold: true, sz: 14, color: { rgb: 'FFFFFF' } },
  fill: { fgColor: { rgb: '007BFF' } },
  alignment: { horizontal: 'center', vertical: 'center' },
};

// Add the column headers and data
XLSX.utils.sheet_add_json(worksheet, worksheetData, { origin: 'A3', skipHeader: false });

// Style the column headers
Object.keys(worksheetData[0] || {}).forEach((key, index) => {
  const cell = worksheet[XLSX.utils.encode_cell({ r: 2, c: index })]; // Row 3 (A3)
  if (cell) {
    cell.s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '007BFF' } },
      alignment: { horizontal: 'center', vertical: 'center' },
    };
  }
});

// Adjust column widths
worksheet['!cols'] = Object.keys(worksheetData[0] || {}).map((key) => {
  if (key === '#') {
    return { wch: 5 }; // Smaller width for the number column
  }
  return { wch: 20 }; // Wider width for other columns
});

// Create a new workbook and append the worksheet
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, 'Data Export');

// Export the workbook as an Excel file
XLSX.writeFile(workbook, 'exported_data.xlsx');
},







add: function(){
          this.count++;
          this.detail.push({
           
          },)
         
      },

remove: function () {
          this.count--;
          this.detail.splice({
            
          },1)
          
      },
 

     









},

  components :{
      ContentFooter,
      TopNavbar,
      'v-select': vSelect,
  },
}

</script>

<style scoped>
.calendar-popup {
position: fixed; /* Fix position relative to the viewport */
top: 40%; /* Center vertically */
left: 50%; /* Center horizontally */
transform: translate(-50%, -50%); /* Adjust for exact centering */
background: #fff;
border: 1px solid #ddd;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
padding: 10px;
border-radius: 8px;
z-index: 1000;
width: 330px;
text-align: center;
}
.calendar-widget {
margin: 10px auto;
}
.button-group {
display: flex;
justify-content: flex-end; /* Align buttons to the right */
margin-top: 10px;
gap: 10px; /* Add space between the buttons */
}
.save-button,
.close-button {
background-color: #007bff;
color: white;
border: none;
border-radius: 4px;
padding: 5px 10px;
cursor: pointer;
}
.save-button:hover {
background-color: #0056b3;
}
.close-button {
background-color: #dc3545;
}
.close-button:hover {
background-color: #a71d2a;
}


</style>